const generateContentExpression = (allowedBlocks: string[]) => {
  //using `+` intead of `*` to avoid empty  nodes (which creates problem with perfromance)
  return allowedBlocks.length ? `(${allowedBlocks.join(' | ')})+` : '';
};

const blocksAllowedInsideTab = [
  'paragraph',
  'blockquote',
  'heading',
  'ordered_list',
  'bullet_list',
  'code_block',
  'image',
  'video',
  'audio',
  'file',
  'webbookmark',
];

const blocksAllowedInsideToggleContent = [
  ...blocksAllowedInsideTab,
  'toggle_list',
  'table',
  'tab_view',
];
const toggleContentBlockContent = generateContentExpression(blocksAllowedInsideToggleContent);

const tabBlockContent = generateContentExpression(blocksAllowedInsideTab);

const blocksAllowedInsideTableCell = [
  'paragraph',
  'blockquote',
  'heading',
  'ordered_list',
  'bullet_list',
  'code_block',
  'image',
  'table',
];

const tableCellContent = generateContentExpression(blocksAllowedInsideTableCell);

export {
  blocksAllowedInsideTab,
  blocksAllowedInsideTableCell,
  blocksAllowedInsideToggleContent,
  tabBlockContent,
  tableCellContent,
  toggleContentBlockContent,
};
